import { createFormAction,  } from 'redux-form-saga';
import { createAction } from 'redux-actions';
import * as phraseFormTypes from './phraseFormTypes';

export const submitPhraseForm = createFormAction(phraseFormTypes.SUBMIT_PHRASE_FORM);
export const onChapterCheckboxClickSelected = createAction(phraseFormTypes.CHAPTER_CHECKBOX_CLICK, chapterCode => ({
  chapterCode,
}));
